import { fetchReviews } from './review'

export const ORDER_REVIEW_PAGE_SIZE = 100
export const MAX_ORDER_REVIEW_PAGES = 20

/**
 * Paginated GET /review?orderId=&userId=. Returns stored reviews as-is.
 * Does not attach relatedPropertyIds; My Escapes still merges LE+bedbank stays in the client
 * via accommodation mapping so one physical hotel is one review row.
 */
export interface FetchAllOrderReviewsParams {
  orderId: string
  userId: string
  showHidden?: boolean
}

export async function fetchAllOrderReviews(
  params: FetchAllOrderReviewsParams,
): Promise<App.ReviewsFetch> {
  let offset = 0
  const reviews: Array<App.Review> = []
  let total = Number.POSITIVE_INFINITY
  let pageCount = 0

  while (reviews.length < total) {
    if (pageCount >= MAX_ORDER_REVIEW_PAGES) {
      throw new Error(`Exceeded ${MAX_ORDER_REVIEW_PAGES} pages fetching order reviews`)
    }
    pageCount++
    const page = await fetchReviews({
      ...params,
      limit: ORDER_REVIEW_PAGE_SIZE,
      offset,
    })
    total = page.total

    if (page.reviews.length === 0) {
      if (reviews.length < total) {
        throw new Error('Order reviews ended before the reported total was loaded')
      }
      break
    }

    reviews.push(...page.reviews)
    offset += page.reviews.length
  }

  return { reviews, total }
}
